// Store select of the delivery target: the option carries the address, the summary line below shows it.
document.addEventListener('alpine:init', () => {
    Alpine.data('filialeSelect', () => ({
        show() {
            this.$el.closest('ul').querySelector('.filial_value').textContent =
                this.$el.selectedOptions[0].dataset.filialAddress;
        },
    }));
});
